import { cn } from "@/app/utils/cn";
import { Badge } from "../../../components/ui/badge";
import { SupportCategoryEnum } from "@/app/utils/supportCategoryEnum";
import { format } from "date-fns";
import { Support } from "@/app/entities/Support";

interface SearchHistoryProps {
  supports: Support[];
  handleMakeFetchAgain: (
    itemSearch: string,
    itemCategories: SupportCategoryEnum[],
  ) => void;
}

export function SearchHistory({
  supports,
  handleMakeFetchAgain,
}: SearchHistoryProps) {
  return (
    <div className="rounded-xl border bg-card p-4">
      <h3 className="text-xs font-medium text-muted-foreground">
        Histórico de pesquisa
      </h3>
      <div className="mt-8 space-y-4">
        {supports.length > 0 ? (
          supports.map((item) => (
            <div
              key={item._id}
              onClick={() =>
                handleMakeFetchAgain(
                  item.props.values[0],
                  item.props.options.length === 3
                    ? [SupportCategoryEnum.ALL]
                    : item.props.options,
                )
              }
              className="flex cursor-pointer items-center justify-between py-2 hover:bg-slate-200"
            >
              <div className="flex items-center gap-1 text-sm">
                <p className="font-semibold">
                  {format(item.createdAt, "dd/MM/yyyy HH:mm")}
                </p>
                <span>-</span>
                <p>Pesquisa em</p>
                <p className="font-bold">{item.props.values[0]}</p>
              </div>
              <div className="flex gap-2">
                {item.props.options.map((category) => (
                  <Badge
                    key={category}
                    variant="outline"
                    className={cn(
                      "flex w-20 items-center justify-center rounded-lg text-[10px]",
                      `${category === SupportCategoryEnum.CUSTOMER && "text-success"}`,
                      `${category === SupportCategoryEnum.USER && "text-info"}`,
                      `${category === SupportCategoryEnum.TRANSACTION && "text-error"}`,
                    )}
                  >
                    {category === SupportCategoryEnum.CUSTOMER && "Cliente"}
                    {category === SupportCategoryEnum.USER && "Vendedor"}
                    {category === SupportCategoryEnum.TRANSACTION && "Proposta"}
                  </Badge>
                ))}
              </div>
            </div>
          ))
        ) : (
          <h2 className="text-center">Não há histórico de pesquisa</h2>
        )}
      </div>
    </div>
  );
}
